import timeslots from './timeslots';
import meals from './meals';
import drinks from './drinks';
import orders from './orders';

const API = {
	timeslots,
	meals,
	drinks,
	orders
};

export default API;
